import '@bnnvara/typography';

import { breakpoints } from '@bnnvara/breakpoints';
import styled from 'styled-components';

import appConfig from '../../config/app.json';

const StyledSubNavigation = styled.nav`
  position: sticky;
  top: ${appConfig.layout.hubHeight}px;
  z-index: 3;
  width: 100%;
  background-color: ${({ theme }) => theme.base.white};
  display: flex;
  justify-content: center;
  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.04);
  ${breakpoints.md} {
    top: ${appConfig.layout.hubHeightMd}px;
  }

  a {
    &:focus {
      outline: none;
    }
  }
`;

export default StyledSubNavigation;
